// Configuración centralizada de la API
const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost',
  PORT: process.env.REACT_APP_API_PORT || '4000',
  
  getFullUrl: function() {
	  if(this.PORT==='80'){
		  return `${this.BASE_URL}`;
	  }else{
		 return `${this.BASE_URL}:${this.PORT}`; 
	  }		  
  },
};

// Función helper para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.getFullUrl()}${endpoint}`;
};

// Función helper para obtener la URL base
export const getBaseUrl = () => {
  return API_CONFIG.getFullUrl();
};

// Función helper para obtener solo la URL sin puerto
export const getBaseUrlWithoutPort = () => {
  return API_CONFIG.BASE_URL;
};

// Función helper para obtener solo el puerto
export const getPort = () => {
  return API_CONFIG.PORT;
};

export default API_CONFIG; 